import React from 'react'
import MobileEmptyStateCard from '../../components/MobileEmptyStateCard'
import { formatMoney, formatDiscountPercent } from '../../helpers/utils'

const netWeightLabel = (model) =>
  Number(model.net_weight || 0) === 0 ? '-' : Number(model.net_weight).toFixed(2)

const OrderInvoiceLineCard = ({ model }) => {
  const staticRows = [
    ['Código', model.product_db_ref],
    ['Peso neto', netWeightLabel(model)],
    ['Unidad', model.unit],
    ['Cantidad', Number(model.quantity || 0).toFixed(2)],
    ['Precio', formatMoney(Number(model.unit_price || 0))],
    ['% descuento', formatDiscountPercent(model.discount)],
    ['Sub-total', formatMoney(Number(model.extended_price || 0))]
  ]

  return (
    <div className="order-detail-line-card">
      <div className="order-detail-line-product-name">{model.product_name}</div>
      {staticRows.map(([label, value]) => (
        <div key={label} className="order-detail-line-row">
          <span className="order-detail-line-label">{label}</span>
          <span className="order-detail-line-value">{value}</span>
        </div>
      ))}
    </div>
  )
}

const OrderInvoiceDetailsTabMobileLines = ({ details }) => {
  if (!details?.length) {
    return (
      <MobileEmptyStateCard
        title="No hay productos"
        description="Cuando esta factura tenga productos asociados, aparecerán aquí."
      />
    )
  }

  return (
    <div className="order-detail-line-items-mobile">
      {details.map((model, index) => (
        <OrderInvoiceLineCard key={index} model={model} />
      ))}
    </div>
  )
}

export default OrderInvoiceDetailsTabMobileLines
